import request, { serviceV2 } from '@/utils/request'

const prefix = '/django_rest/hm'
const serviceV2Prefix = '/hm'

export default {
  getResumeDownloadUrl (jobId, candidateId, params) {
    return serviceV2.get(`${serviceV2Prefix}/application/job/${jobId}/candidate/${candidateId}/resume-download/`, { params })
  },
  getHMDashBoardData () {
    return request.get(`${prefix}/dashboard/`)
  },
  getHmInfoByResetCode (resetCode) {
    return request.get(`${prefix}/create-password/${resetCode}`)
  },
  createHmPassword (resetCode, formData) {
    return request.post(`${prefix}/create-password/${resetCode}`, formData)
  },
  forgetHmPassword (formData) {
    return request.post(`${prefix}/reset-password/`, formData)
  },
  hmLogin (params) {
    return request.post(`${prefix}/login/`, params)
  },
  hrAutoLoginHm () {
    return request.get(`${prefix}/login/`)
  },
  getHmInfo () {
    return request.get(`${prefix}/info/`)
  },
  switchRootCompany (rootCompanyId) {
    return request.post(`${prefix}/root-company/switch/`, { root_company_id: rootCompanyId })
  },
  resolveRootCompany (params) {
    return request.get(`${prefix}/root-company/resolve/`, { params })
  },
  getRatingInfoByInviteCode (inviteCode) {
    return request.get(`${prefix}/rate/${inviteCode}`)
  },
  saveRatingResultByInviteCode (inviteCode, params) {
    return request.post(`${prefix}/rate/${inviteCode}`, params)
  },
  getInterviewInfoByInviteCode (inviteCode) {
    return request.get(`${prefix}/interview/${inviteCode}`)
  },
  saveInterviewRatingResultByInviteCode (inviteCode, params) {
    return request.post(`${prefix}/interview/${inviteCode}`, params)
  },
  getHmQuestionList (params) {
    return request.get(`${prefix}/invite/job-question/`, { params })
  },
  sendInviteHm (params) {
    return request.post(`${prefix}/invite/rating/`, params)
  },
  resendInviteHm (params) {
    return request.put(`${prefix}/invite/rating/${params.invite_code}/`, params)
  },
  getHmListForInvite (params) {
    return request.get(`${prefix}/invite/`, { params })
  },
  getHMRateList (params) {
    return serviceV2.get(`${serviceV2Prefix}/resume/rate/`, { params })
  },
  previewInviteRateEmail (params) {
    return request.post(`${prefix}/preview-invite-email/`, params)
  },
  getCompanyHmList (params) {
    return request.get(`${prefix}/`, { params })
  },
  updateCompanyHm (companyHMId, data) {
    return request.put(`${prefix}/${companyHMId}/`, data)
  },
  saveCompanyHm (data) {
    return request.post(`${prefix}/`, data)
  },
  hmEmailValidate (params) {
    return request.get(`${prefix}/email-validate/`, { params })
  },
  getCompanyHm (companyHMId) {
    return request.get(`${prefix}/${companyHMId}/`)
  },
  resetCompanyHMPasswordByHR (companyHMId) {
    return request.get(`${prefix}/${companyHMId}/reset-password/`)
  },
  getInterviewRecordInfo (interviewUuid, params) {
    return serviceV2.get(`${serviceV2Prefix}/interview/record/${interviewUuid}/`, { params })
  },
  updateInterviewRecordInfo (interviewUuid, data) {
    return serviceV2.post(`${serviceV2Prefix}/interview/record/${interviewUuid}/operation/`, data)
  },
  updateInterviewRecordOnlineInfo (interviewUuid, data) {
    return serviceV2.post(`${serviceV2Prefix}/interview/record/${interviewUuid}/update-online-info/`, data)
  },
  getHMInterviewRateList (params) {
    return serviceV2.get(`${serviceV2Prefix}/interview/rate-list/`, { params })
  },
  getScheduleList (data) {
    return serviceV2.post(`${serviceV2Prefix}/interview/schedule/`, data)
  },
  hmCheckMicrosoftGraphAuth () {
    return serviceV2.get(`${serviceV2Prefix}/microsoft-graph/check-auth/`)
  },
  hmCreateOnlineMeetingEvent (params) {
    return serviceV2.post(`${serviceV2Prefix}/microsoft-graph/online-meeting-event/`, params)
  },
  hmUpdateOnlineMeetingEvent (params) {
    return serviceV2.put(`${serviceV2Prefix}/microsoft-graph/online-meeting-event/`, params)
  },
  hmDeleteOnlineMeetingEvent (eventId) {
    return serviceV2.delete(`${serviceV2Prefix}/microsoft-graph/online-meeting-event/${eventId}/`)
  }
}
